// test2598
(2598 && 0);
